module.exports = __webpack_public_path__ + "img/57c40df.jpg";